import { render, staticRenderFns } from "./SearchbarInput.vue?vue&type=template&id=476c91c2&scoped=true"
import script from "./SearchbarInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchbarInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchbarInput.vue?vue&type=style&index=0&id=476c91c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c91c2",
  null
  
)

export default component.exports